import HomeView from './home-view';

export default HomeView;
